import { apiRequest } from '../http/httpClient';

export const authApi = {
  login(credentials) {
    return apiRequest('/api/auth/login', {
      method: 'POST',
      body: credentials,
    });
  },

  /** Devuelve { token }: el registro hace auto-login. */
  register(customer) {
    return apiRequest('/api/auth/register', {
      method: 'POST',
      body: customer,
    });
  },
};
